export default __webpack_public_path__ + "static/media/t.d4812ef0.mp3";